<template>
  <div class="meal-list">
    <div
      class="meal-type-list"
      v-for="(dietTypeItem, dietTypeIndex) in data"
      :key="dietTypeIndex"
    >
      <div class="meal-item">
        <div
          class="meal-item-wrapper"
          @click="bindClick(dietTypeItem.data[0])"
          v-if="dietTypeItem.data.length == 1"
        >
          <div class="meal-image" v-if="!dietTypeItem.data[0].is_super">
            <van-image
              class="meal-icon"
              lazy-load
              radius="4"
              fit="cover"
              :src="dietTypeItem.data[0].thumb_image_url | filterUrl"
            />
          </div>
          <div class="meal-image super-food" v-else>
            <van-image
              class="meal-icon"
              lazy-load
              radius="4"
              fit="cover"
              :src="dietTypeItem.data[0].thumb_image_url | filterUrl"
            />
            <img
              class="meal-flag"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/159a9ada5ca72d0571bd0c2464441200.png"
              alt=""
            />
          </div>
          <div class="meal-right">
            <div class="meal-r-top"
              ><span class="meal-name">{{ dietTypeItem.data[0].name }}</span
              ><span class="meal-unit"
                >x{{ dietTypeItem.data[0].food_weight | filterUnitNumber
                }}{{ dietTypeItem.data[0].specs_name }}</span
              >
            </div>
            <div class="meal-type">{{
              dietTypeItem.data[0].food_attr_name
            }}</div>
          </div>
        </div>
        <!-- 组合版本 -->
        <div class="meal-item-group" v-if="dietTypeItem.data.length > 1">
          <div class="group-left">
            <div
              class="group-item"
              @click="bindClick(groupitem)"
              v-for="(groupitem, groupindex) in dietTypeItem.data"
              :key="groupindex"
            >
              <div class="meal-image" v-if="!groupitem.is_super">
                <van-image
                  class="meal-icon"
                  lazy-load
                  radius="4"
                  fit="cover"
                  :src="groupitem.thumb_image_url"
                />
              </div>
              <div class="meal-image super-food" v-else>
                <van-image
                  class="meal-icon"
                  lazy-load
                  radius="4"
                  fit="cover"
                  :src="groupitem.thumb_image_url"
                />
                <img
                  class="meal-flag"
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/159a9ada5ca72d0571bd0c2464441200.png"
                  alt=""
                />
              </div>
              <div class="meal-right">
                <div class="meal-r-top">
                  <span class="meal-name">{{ groupitem.name }}</span>
                </div>
                <div class="meal-type">{{ groupitem.food_attr_name }} </div>
              </div>
            </div>
          </div>
          <div class="group-right">
            <div class="group-dash"></div>
            <div class="meal-unit"
              >x{{ dietTypeItem.data | filterGroupUnit }}</div
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  filters: {
    filterUnitNumber(num) {
      num = +num
      return num == 0.5 ? '半' : num
    },
    filterUrl(url) {
      if (url) {
        url = url + '?x-oss-process=image/resize,w_176/quality,Q_100'
      }
      return url
    },
    //组合单位
    filterGroupUnit(data) {
      return (data.length && data[0].specs_name) || ''
    }
  },
  methods: {
    bindClick(item) {
      this.$emit('into', item)
    },
    getGroupUnit() {}
  }
}
</script>
<style lang="scss" scoped>
.meal-list {
  .meal-type-list {
    margin-bottom: 8px;
  }
  .meal-item {
    background: #ffffff;
    border-radius: 6px;
    padding: 8px;

    .meal-item-group,
    .meal-item-wrapper {
      display: flex;
      align-items: center;

      .meal-image {
        margin-right: 10px;
        position: relative;
        width: 44px;
        height: 44px;
        .meal-icon {
          border-radius: 6px;
          overflow: hidden;
          width: 44px;
          height: 44px;
          object-fit: contain;
        }
      }

      .super-food {
        .meal-icon {
          border-radius: 8px;
        }

        .meal-flag {
          width: 44px;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0%);
          bottom: 0;
          z-index: 2;
        }
      }

      .meal-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .meal-r-top {
          display: flex;
          align-items: center;
          .meal-name {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.8);
            line-height: 20px;
          }
          .meal-unit {
            white-space: nowrap;
            min-width: 25px;
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
          }
        }

        .meal-type {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 14px;
        }
      }

      .meal-unit {
        margin-left: 4px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 17px;
        color: rgba(0, 0, 0, 0.3);
      }
    }

    .meal-item-group {
      display: flex;
      align-items: center;

      .group-left {
        max-width: 200px;
        .group-item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }

        .group-item:last-child {
          margin-bottom: 0;
        }
      }

      .group-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        display: flex;
        align-items: center;
        margin-left: 6px;

        .group-dash {
          border-radius: 0px 2px 2px 0px;
          box-sizing: border-box;
          width: 10px;
          height: 56px;
          border: 1px dashed rgba(0, 0, 0, 0.3);
          border-left: none;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
